import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    const isProd = environment.production;
    const isWorkflowDomain = window.location.origin === 'https://www.workflow.space';

    if (isProd && isWorkflowDomain) {
      this.addGTM();
    }
  }

  addGTM(): void {
    const gmtKey = environment.gmt;
    if (!gmtKey) return;

    // Cookie consent
    const defaultConsent = this.document.createElement('script');
    defaultConsent.setAttribute('data-cookieconsent', 'ignore');
    defaultConsent.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('consent', 'default', {
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'granted',
        'wait_for_update': 500
      });
      gtag('set', 'ads_data_redaction', true);
      gtag('set', 'url_passthrough', false);
    `;
    this.document.head.appendChild(defaultConsent);

    // GA4 library
    const ga = this.document.createElement('script');
    ga.async = true;
    ga.src = `https://www.googletagmanager.com/gtag/js?id=${gmtKey}`;
    this.document.head.appendChild(ga);

    // Config
    const gaConfig = this.document.createElement('script');
    gaConfig.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${gmtKey}');
    `;
    this.document.head.appendChild(gaConfig);
  }
}
